
define('text!plugins/datetime/setupTemplate.html',[],function () { return '';});

